module.exports = __webpack_public_path__ + "img/logo-zongshen.90588d8f.png";